var React = require('react');

function BgMoon1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M91.2646 214.191C139.548 230.924 192.236 206.983 211.747 160.604C207.367 159.711 203.084 158.539 198.897 157.089C148.939 139.776 122.772 85.3827 139.987 35.7073C140.857 33.1956 141.631 30.963 142.78 28.548C95.5359 18.7402 47.6786 44.9805 31.6245 91.307C14.1198 141.82 40.7481 196.685 91.2646 214.191Z","fill":"#EB5A30"}));
}

BgMoon1.defaultProps = {"width":"246","height":"246","viewBox":"0 0 246 246","fill":"none"};

module.exports = BgMoon1;

BgMoon1.default = BgMoon1;
